<div class="login-container">
  <login-credentials-form [loginForm]="loginForm"></login-credentials-form>
</div>
